import { gql } from "apollo-boost";

export const CREATE_WARNING_ADDRESSES = gql`
  mutation createWarningAddresses($input: [WarningAddressCreateInput!]!) {
    createWarningAddresses(input: $input)
  }
`;

export const UPDATE_WARNING_ADDRESS = gql`
  mutation updateWarningAddress($input: WarningAddressUpdateInput!) {
    updateWarningAddress(input: $input)
  }
`;

export const DELETE_WARNING_ADDRESS = gql`
  mutation deleteWarningAddress($id: ID!) {
    deleteWarningAddress(id: $id)
  }
`;
